function getMobileOperatingSystem() {
  const userAgent = window
    ? window?.navigator?.userAgent || window?.navigator?.vendor
    : navigator?.userAgent || navigator?.vendor;

  if (/android/i.test(userAgent)) return 'Android';

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS';

  return 'unknown';
}

export default getMobileOperatingSystem;
